import { useEffect, useRef } from 'react';

// ==============================|| INTERVAL HOOK ||============================== //

const useInterval = (callback, timer) => {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        const fn = () => {
            savedCallback.current();
        };

        if (timer !== null) {
            const intervalId = setInterval(fn, timer);
            return () => clearInterval(intervalId);
        }
    }, [timer]);
};

export default useInterval;
